import React from 'react';
import Types from '../../constants/Types';
import ObjectOverride from '../ObjectOverride';
import ModuleCard from './ModuleCard';

class LocationsList extends ObjectOverride {
	constructor(props) {
		super(props, Types.Locations_Modules._name);
	}

	render() {
		// Destructuring for cleaner code
		const { object, history, rootState, handleAfterSave } = this.props;
		const { subscriptions, selectedActualLocation, locations, location, location_binary_id } = object;
		const { locationSelected, locationSelectedBinaryId } = rootState;

		const isEnterpriseSubscription = selectedActualLocation[0].subscriptions?.id === ['ffl_enterprise', 'ffl_enterprise_1', 'ffl_enterprise_2', 'ffl_enterprise_4', 'ffl_enterprise_05', 'ffl_enterprise_5', 'ffl_enterprise_6'];
		return (
			<>
				<hr></hr>
				<h4 style={{ fontWeight: 'bold' }}>Locations Subscriptions</h4>
				<div className={'row'} id={'moduleCardsContainer'}>
					{/*Account Subscription Modules*/}

					{subscriptions?.items && subscriptions.items.map((data, key) => {
						let found = false;
						if (selectedActualLocation[0].subscriptions?.pkey === data.pkey) {
							found = true;
						}
						return (
							<ModuleCard
								moduleClass={""}
								price={data.price}
								moduleId={data.id}
								borderStyle={found ? '#1bbc9b' : '#dbdbdb'}
								type={data.description}
								ffl={locations.ffl}
								name={selectedActualLocation[0]?.name}
								history={history}
								isSubscribed={found}
								locationBinaryId={locationSelected ? locationSelectedBinaryId : (location ? location_binary_id : rootState.locations[0].binary_id)}
								location={locationSelected ? locationSelected : (location ? location : rootState.locations[0].pkey)}
								locationSelected={selectedActualLocation[0]}
								isDisabled={isEnterpriseSubscription}
								handleAfterSave={handleAfterSave}
								key={key}
							/>
						);
					})}
				</div>
			</>
		);
	}
}

export default LocationsList;